/**
 * SuperAdminLayout.js — Wrapper léger v3.9 (Lot 1 — Centralisation Sidebar)
 * Source unique : components/Layout/AppLayout.js
 *
 * Remplace MainLayout.js + Sidebar.js (ancien code dupliqué) pour le rôle superadmin.
 * Icônes harmonisées avec les autres rôles (Admin/Client/Intervenant).
 */
import React from 'react';
import AppLayout from '../components/Layout/AppLayout';
import { SUPERADMIN_NAV } from '../config/roleNavigation';

const SuperAdminLayout = () => <AppLayout navItems={SUPERADMIN_NAV} />;

export default SuperAdminLayout;
